export const API_URL = true
  ? "https://rio-tickets.site/api/"
  : "http://localhost/riotickets-api/";
